// import borders from "../../Theme/base/borders";
// import pxToRem from "../../Theme/functions/pxToRem";
import borders from "../../Theme/base/borders";

import pxToRem from "../../Theme/functions/pxToRem";

// const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
  display: "flex !important",
  justifyContent: "center",
  whiteSpace: "nowrap",
  alignItems: "center",
  // fontSize: pxToRem(14),
  borderRadius: borderRadius.sm,
  // padding: `0.375rem 7.5rem`,
  lineHeight: "1.25rem",
  border: "none",
  fontFamily: "var(--font-inter)",
  //   textAlign: "center",
  fontWeight: 400,
  boxShadow: "none !important",
  // textTransform: "uppercase",
  //   userSelect: "none",
  backgroundSize: "150% !important",
  backgroundPositionX: "25% !important",
  transition: "all 150ms ease-in",

  "&:disabled": {
    pointerEvent: "none",
    // fontSize: pxToRem(14),
    fontWeight: 400,
    lineHeight: "1.25rem" /* 142.857% */,
  },

  "& .material-icons": {
    fontSize: pxToRem(15),
    marginTop: pxToRem(-2),
  },
};
